import { REQUEST } from '@/constants/api';

import { Option } from '@/types/components/common';
import { DictionaryType } from '@/types/dictionary';
import { BusinessCategory, Occupation } from '@/types/user';

import { getSortOptionsFn } from '@/utils/common';

import { axios } from './axios';

export const getOccupationOptions = async (dictionaryType?: DictionaryType) => {
  const result = await axios.get<Occupation[]>(
    REQUEST.EMPLOYMENT.OCCUPATIONS +
      (dictionaryType ? `?dictionaryType=${dictionaryType}` : ''),
  );

  return result.data
    .map(
      ({ code, value }) =>
        ({
          value: code,
          text: value,
        }) as Option,
    )
    .sort(getSortOptionsFn('asc'));
};

export const getBusinessCategories = async () => {
  const result = await axios.get<BusinessCategory[]>(
    REQUEST.EMPLOYMENT.BUSINESS_CATEGORIES,
  );

  return result.data
    .map(
      ({ code, value }) =>
        ({
          value: code,
          text: value,
        }) as Option,
    )
    .sort(getSortOptionsFn('asc'));
};
